export default __webpack_public_path__ + "static/home-page-top-bg-8f168b2aa3f8a2e210aeecceb9615cb4.jpg";